export const otGtmAlert = {
    // Default GTM Alert functionality relies on Bootstrap 4 alert functionality for dismissal
    // so adding this here to replicate that behavior
    init() {
        window.addEventListener('click', (e) => {
            const target = e?.target;

            if (target instanceof Element && target.closest(`[data-dismiss="alert"]`)) {
                const $alertFixedContainer = target.closest('.alert-fixed-container');

                if (!$alertFixedContainer) return;

                // If there is more than one alert in the fixed container, only remove the clicked alert (and its container)
                if ($alertFixedContainer.querySelectorAll('.alert').length > 1) {
                    const $alert = target.closest('.alert');
                    $alert?.parentElement?.remove();
                } else {
                    $alertFixedContainer.remove();
                }
            }
        });
    }
}